import { z } from "@reflag/shared/utils/zod";

export const EnvironmentTypeSchema = z
  .enum(["test", "smoketest", "local", "staging", "production", "review"])
  .optional()
  .default("local");
